import { createSelector } from 'reselect';

const notificationSelector = (state: any) => state.notification;

export const notificationList = createSelector(notificationSelector, state => state.notification);
// export const notificationCurrentItems = createSelector(notificationSelector, state => state.currentItems);
export const notificationTotalItems = createSelector(notificationSelector, state => state.totalItems);
export const notificationUnSeenCount = createSelector(notificationSelector, state => state.unSeenCount);
